<template>
  <ul v-show="!hideStoryInput" id="editType" class="edit-type" @click="canvasOut">
    <a
      v-if="parrent.createPattern > 0"
      href="javascript:;"
      class="preview"
      @click="storyOperation()"
      v-text="previewNote"
    >
    </a>
    <li class="list">
      <a href="javascript:;" class="edit-role" @click="editWidget('role', 9)"
         v-if="useRole.name === ''">
        <img src="../../static/image/stage_role_normal.png" alt="空">
      </a>
      <a href="javascript:;" class="edit-role" @click="editWidget('role', 9)"
         v-else-if="useRole.name === '旁白'">旁白</a>
      <a href="javascript:;" class="edit-role" @click="editWidget('role', 9)" v-else>
        <img :src="useRole.cover">
      </a>
    </li>
    <li class="list">
      <textarea v-model="$store.state.editMsgText" placeholder="点击输入文字" ref="editBox" @click.prevent="focusDispose()" class="edit-note" id="editStoryInput"></textarea>
    </li>
    <li class="list">
      <a href="javascript:;" class="edit-media" @click="editWidget('media', 11)"></a>
    </li>
    <!--<li class="list" v-if="parrent.createPattern === 1">
      <img :src="moodList[moodType].src" class="mood-list" @click="editWidget('mood')">
    </li>-->
    <li class="list">
      <a href="javascript:;" class="send" @mousedown="sendMsg('txt')">确认</a>
    </li>
  </ul>
</template>

<script>
  import {mapState} from 'vuex';
  import {Popup} from 'mint-ui';
  import store from '../store/store';
  import {ProjectData} from '../store/ProjectData';
  import {ComponentName, Methods, CanvasCommand} from '../const/common';

  export default {
    name: "edit_store_tool",
    props: ['moodType'],
    computed: {
      watchGuideStep3() {
        return this.guideConf.dispose['step3'];
      },
      watchGuideStep5() {
        return this.guideConf.dispose['step5'];
      },
      ...mapState(['visualEdit', 'parrent', 'useRole', 'moodList', 'hideStoryInput', 'guideConf'])
    },
    data() {
      return {
        projectData: new ProjectData(this),
        previewNote: '分镜预览'
      }
    },
    methods: {
      storyOperation() {
        var _res = !this.visualEdit;

        if (_res) {
          this.previewNote = '退出预览';
        } else {
          this.previewNote = '分镜预览';
        }
        store.state.visualEdit = !this.visualEdit;
        Methods.checkChapterHash(17);
      },
      focusDispose() {
        this.$refs.editBox.blur();
        Methods.cutComponent([ComponentName.EDIT_STORY_TEXT], true);
        Methods.checkChapterHash(10);
      },
      canvasOut() {
        Methods.canvasOut();
      },
      editWidget(type, hash) {
        this.$emit('openWidget', type);
        Methods.checkChapterHash(hash);
      },
      sendMsg() {
        Methods.sendTextMsg('txt');
        Methods.checkChapterHash(12);
      }
    },
    watch: {
      watchGuideStep3() {
        this.focusDispose();
        store.state.guideConf.nowProgress = 4;
      }
    }
  }
</script>

<style scoped>
  @import "../style/css/edit_story_tool.css";
</style>



// WEBPACK FOOTER //
// src/components/edit_story_tool.vue